import SvgIcon from '@mui/material/SvgIcon';

const KwikIcon = (props) => {
  return (
    <SvgIcon {...props}>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="18.000000pt" height="18.000000pt" viewBox="0 0 48.000000 48.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M51 429 c-23 -67 -7 -129 40 -155 22 -12 23 -13 4 -14 -12 0 -26 5
-33 12 -9 9 -15 9 -23 1 -9 -9 -4 -20 20 -43 17 -17 31 -38 31 -45 0 -8 9 -19
19 -24 10 -6 29 -31 41 -56 18 -37 20 -48 10 -60 -19 -22 -4 -31 30 -18 21 8
41 8 65 2 107 -30 214 85 184 196 -26 93 -136 143 -220 100 -28 -15 -32 -14
-59 5 -40 28 -67 65 -75 100 -8 39 -20 38 -34 -1z m119 -116 c89 -59 120 -95
120 -138 0 -32 -3 -35 -29 -35 -48 0 -135 20 -149 34 -11 10 -8 12 18 8 41 -6
38 14 -3 22 -19 3 -44 18 -57 31 l-24 25 31 -11 c17 -6 46 -9 65 -7 l33 4 -43
18 c-71 31 -95 80 -75 155 6 22 7 20 27 -20 15 -32 38 -55 86 -86z m197 -11
c79 -50 83 -162 9 -231 -31 -29 -35 -17 -5 16 30 31 37 109 14 156 -9 20 -32
46 -51 58 -19 11 -34 22 -34 24 0 7 46 -9 67 -23z"/>
</g>
</svg>

        </SvgIcon>
  );
}

export default KwikIcon